module.exports = __webpack_public_path__ + "media/src/assets/images/img-travel-europe-3a7029d99d9f679c7bb4600a90cb4671.png";